export default __webpack_public_path__ + "static/subadaiboldital-2e8ac1a0ef83d11d24fdc832adff749c.woff";